import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import * as R from "ramda";
import Avatar from "@material-ui/core/Avatar";
import { path } from "ramda";
import { Field } from "react-final-form";
import { clienteApi, ibgeApi } from "../../services/Api";
import { withStyles } from "@material-ui/core/styles";

import { TextField } from "final-form-material-ui";

import {
  CrudForm,
  FormApi,
  ImagePicker,
  Autocomplete,
  Checkbox,
  Select,
  DatePicker,
} from "elentari";
import genders from "../../utils/genders";
import history from "../../utils/history";
import moment from "moment";

const styles = (theme) => ({
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

function ClienteForm({ classes, ...props }) {
  const validate = (values) => ({
    nome: values.nome ? undefined : "Obrigatório",
    email: values.email ? undefined : "Obrigatório",
    senha:
      values.senha || props.match.params.id !== "new"
        ? undefined
        : "Obrigatório",
    dataNascimento: values.dataNascimento ? undefined : "Obrigatório",
    genero: values.genero ? undefined : "Obrigátorio",
  });

  const [municipios, setMunicipios] = useState([]);

  const fetchMunicipios = async () => {
    const response = await ibgeApi.getMunicipios();
    if (response.ok) {
      setMunicipios(
        response.data.map((m) => ({
          label: `${m.microrregiao.mesorregiao.UF.sigla} ${m.nome}`,
          value:
            `${m.microrregiao.mesorregiao.UF.sigla} ${m.nome}`.toUpperCase(),
        }))
      );
    }
  };

  const loadMunicipios = (inputValue) => {
    const values = R.pipe(
      R.filter((municipio) =>
        new RegExp(inputValue.toUpperCase()).test(municipio.value)
      ),
      R.take(5)
    )(municipios);
    return Promise.resolve(values);
  };

  useEffect(() => {
    fetchMunicipios();
  }, [props.match.params.id]);

  const mountFileUpload = (files) => {
    const formData = new FormData();
    formData.append("image", files[0].file);
    return formData;
  };

  const submitDecorator = async ({ id, data, handleSubmit }) => {
    const values = {
      id,
      data: {
        ...data,
        altura: Number(data.altura) || undefined,
        pesoMeta: Number(data.pesoMeta) || undefined,
        imagemPerfilOriginal: data.imagemPerfil
          ? data.imagemPerfilOriginal
          : undefined,
        cidade: path(["cidade", "label"], data),
        dataProximaConsulta: data.dataProximaConsulta
          ? data.dataProximaConsulta
          : null,
      },
    };
    delete values.data.dataBloqueio;
    if (!values.data.dataProximaConsulta)
      delete values.data.dataProximaConsulta;
    const result = await handleSubmit({ ...values });
    if (result.ok) {
      if (Array.isArray(data.imagemPerfil)) {
        await clienteApi.uploadImagemPerfil(
          path(["data", "id"], result) || id,
          mountFileUpload(data.imagemPerfil)
        );
      }
      history.go(0);
    }
    return result;
  };

  const getItemDecorator = async ({ getItem }) => {
    const item = await getItem();
    return {
      ...item,
      cidade: { label: item.cidade, value: item.cidade },
      dataBloqueio: item.dataBloqueio
        ? moment(item.dataBloqueio).add(3, "hours").format("MM/DD/YYYY")
        : null,
    };
  };

  return (
    <FormApi
      {...props}
      initialData={{ ativo: true }}
      getItemDecorator={getItemDecorator}
      submitDecorator={submitDecorator}
      api={clienteApi}
    >
      {({ handleSubmit, getItem }) => (
        <CrudForm
          validate={validate}
          history={props.history}
          getItem={getItem}
          onSubmit={handleSubmit}
        >
          <Grid container spacing={8}>
            <Grid item sm={4} md={2} xs={12} className={classes.imageContainer}>
              <Field
                classes={classes}
                size={150}
                defaultImage={require("../../images/empty-avatar.png")}
                component={(props) => (
                  <ImagePicker {...props} component={Avatar} />
                )}
                name="imagemPerfil"
              />
            </Grid>
            <Grid item sm={8} md={10} xs={12}>
              <Grid container spacing={16}>
                <Grid item sm={4} xs={12}>
                  <Field
                    fullWidth
                    autoFocus
                    component={TextField}
                    label="Nome"
                    name="nome"
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Field
                    fullWidth
                    component={TextField}
                    label="Alias"
                    name="alias"
                  />
                </Grid>
                <Grid item sm={4} style={{ textAlign: "right" }} xs={12}>
                  <Field
                    type="checkbox"
                    color="primary"
                    label="Ativo"
                    component={Checkbox}
                    name="ativo"
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Field
                    fullWidth
                    component={Select}
                    options={genders}
                    label="Gênero"
                    name="genero"
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Field
                    fullWidth
                    component={TextField}
                    label="E-mail"
                    name="email"
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Field
                    fullWidth
                    type="password"
                    component={TextField}
                    label="Senha"
                    name="senha"
                  />
                </Grid>

                <Grid item sm={4} xs={12}>
                  <Field
                    fullWidth
                    component={DatePicker}
                    label="Data Nascimento"
                    name="dataNascimento"
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Field
                    type="number"
                    fullWidth
                    component={TextField}
                    label="Altura em cm"
                    name="altura"
                  />
                </Grid>
                <Grid item sm={4} xs={12}>
                  <Field
                    type="number"
                    fullWidth
                    component={TextField}
                    label="Peso Meta"
                    name="pesoMeta"
                  />
                </Grid>
                <Grid item sm={4}>
                  <Field
                    fullWidth
                    id="municipio"
                    loadOptions={loadMunicipios}
                    component={Autocomplete}
                    label="Cidade"
                    name="cidade"
                  />
                </Grid>
                <Grid item sm={4}>
                  <Field
                    fullWidth
                    component={DatePicker}
                    label="Data Próxima Consulta"
                    name="dataProximaConsulta"
                  />
                </Grid>
                <Grid item sm={4}>
                  <Field
                    fullWidth
                    component={DatePicker}
                    label="Data bloqueio"
                    name="dataBloqueio"
                    disabled
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CrudForm>
      )}
    </FormApi>
  );
}

export default withStyles(styles)(ClienteForm);
